import config from 'Config';

export default {
  mounted() {
    if (window.__prerender) return;
    this.$_formHubspot_initTimeout = setTimeout(() => {
      this.$_formHubspot_initTimeout = null;
      this.$_formHubspot_addContainer();
      this.$_formHubspot_init();
    }, 5000);
  },
  computed: {
    $_formHubspot_containerId() {
      return `hbspt-form-${this.model.$hsFormId}`;
    },
  },
  beforeDestroy() {
    clearTimeout(this.$_formHubspot_initTimeout);
    this.$_formHubspot_clearContainer();
  },
  methods: {
    $_formHubspot_init() {
      if (window.hbspt && window.hbspt.forms) {
        this.$_formHubspot_createForm();
        return;
      }
      const scriptTag = document.querySelector('script[src="//js.hsforms.net/forms/v2.js"]');
      if (scriptTag) {
        scriptTag.addEventListener('load', this.$_formHubspot_createForm);
      } else {
        this.$_formHubspot_addScript();
      }
    },
    $_formHubspot_addScript() {
      const scriptTag = document.createElement('script');
      scriptTag.src = '//js.hsforms.net/forms/v2.js';
      scriptTag.defer = true;
      scriptTag.addEventListener('load', this.$_formHubspot_createForm);
      document.body.appendChild(scriptTag);
    },
    $_formHubspot_addContainer() {
      const container = document.createElement('div');
      container.id = this.$_formHubspot_containerId;
      container.className = 'd-none';
      this.$el.appendChild(container);
      this.$_formHubspot_container = container;
    },
    $_formHubspot_createForm() {
      window.hbspt.forms.create({
        portalId: config.hubspotPortalId,
        formId: this.model.$hsFormId,
        // Put here fake id, so form will not render
        target: `#${this.$_formHubspot_containerId}`,
        onBeforeFormInit: this.$_formHubspot_clearContainer,
      });
    },
    $_formHubspot_clearContainer() {
      if (this.$_formHubspot_timeout || this.$_formHubspot_initTimeout) return;
      const container = this.$_formHubspot_container;
      this.$_formHubspot_timeout = setTimeout(() => {
        container.parentNode.removeChild(container);
      }, 3000);
    },
  },
};
